import { ExchangeCode } from "@/lib/market-data/market-data.types";

/**
 * Exchanges whose public REST/WS endpoints send CORS headers that allow
 * browser requests from our app origin.
 *
 * Verified via preflight/GET with Origin: https://app.trigger.fun
 * - binance: access-control-allow-origin: *
 * - bybit: access-control-allow-origin: https://app.trigger.fun
 * - hyperliquid: access-control-allow-origin: *
 *
 * Blocked in browser (no Access-Control-Allow-Origin on responses):
 * - gate, kucoin
 */
export const BROWSER_DIRECT_CANDLE_EXCHANGES: ExchangeCode[] = [
  "binance",
  "bybit",
  "hyperliquid",
  "asterdex",
];

export function supportsBrowserDirectCandleRest(
  exchange: ExchangeCode
): boolean {
  return BROWSER_DIRECT_CANDLE_EXCHANGES.includes(exchange);
}

export function supportsBrowserDirectCandleWs(
  exchange: ExchangeCode
): boolean {
  return supportsBrowserDirectCandleRest(exchange);
}

export function requiresApiCandleFallback(exchange: ExchangeCode): boolean {
  return !supportsBrowserDirectCandleRest(exchange);
}
